import { Injectable } from '@angular/core';
import { LocationService } from '../../services/location/location.service';
import { Observable } from 'rxjs';
import { CommonHelperService } from '../../utilities/common-helper/common-helper.service';
import { Mapper } from '@dynamic-mapper/angular';
import { LocationDTO } from 'src/app/domain/location/location.dto';
import { Location } from '../../models/common/location.model';
import { LocationProfile } from '../../mappings/location/location.mapping';

@Injectable({
  providedIn: 'root'
})
export class LocationBusinessService {

  constructor(
    private locationService: LocationService,
    private commonHelper: CommonHelperService,
    private readonly mapper: Mapper
  ) { }

  getLocationList(clientId): Observable<LocationDTO[]> {
    return new Observable((observer) => {
      this.locationService.getLocationList(clientId).subscribe({
        next: (response: Location[]) => {
          let result: LocationDTO[] = [];
          result = this.commonHelper.genericArrayMapper(response, LocationProfile.DtoToDomain);
          observer.next(result);
        },
        error: ((error) => {
          observer.error(error);
        })
      });
    })
  }

  getCountryList() {
    return new Observable((observer) => {
      this.locationService.getCountryList(). subscribe({
        next: (response) => {
          try {
            observer.next(response)
          }
          catch (e) {
            observer.error(e);
          }
        },
        error: (error) => {
          observer.error(error);
        }
      })
    })
  }

  getStateList(country): Observable<any> {
    return new Observable((observer) => {
      this.locationService.getStateList(country).subscribe({
        next: (response) => {
          observer.next(response);
        },
        error: ((error) => {
          observer.error(error);
        })
      });
    })
  }

  createLocation(data): Observable<any> {
    return new Observable((observer) => {
      this.locationService.createLocation(data).subscribe({
        next: (response) => {
          observer.next(response);
        },
        error: ((error) => {
          observer.error(error);
        })
      });
    })
  }

  getTimezone(paramsReq): Observable<any> {
    return new Observable((observer) => {
      this.locationService.getTimezone(paramsReq).subscribe({
        next: (response) => {
          observer.next(response);
        },
        error: ((error) => {
          observer.error(error);
        })
      });
    })
  }
}
